// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import Alpine from 'alpinejs'
import './alpine'

// Import Tailwind Elements (Catalyst)
import '@tailwindplus/elements'

// Make Alpine available globally
window.Alpine = Alpine
// Start Alpine
Alpine.start()
